import { SVGProps } from 'react';

export const IconImportCSV = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.0405 3.9999C2.46585 3.9999 2 4.46574 2 5.04039V18.9596C2 19.5343 2.46585 20.0001 3.0405 20.0001H15.9597C16.5344 20.0001 17.0002 19.5343 17.0002 18.9596V12.9998H21.5838C21.8136 12.9998 22 12.8135 22 12.5836V11.416C22 11.1862 21.8136 10.9998 21.5838 10.9998H17.0002V5.04039C17.0002 4.46574 16.5343 3.9999 15.9597 3.9999H3.0405ZM17.0002 10.9998H13.6789V8.77744C13.6789 8.44502 13.3084 8.24675 13.0318 8.43114L8.19826 11.6535C7.95115 11.8183 7.95115 12.1814 8.19826 12.3461L13.0318 15.5685C13.3084 15.7529 13.6789 15.5546 13.6789 15.2222V12.9998H17.0002V10.9998Z'
        fill='currentColor'
      />
    </svg>
  );
};
